import * as React from "react";
import TeacherPortalLearningMaterialInteractionChart from "../learning_materials/LearningMaterialInteractionChart";
import TeacherPortalQuizResultsChart from "../chart/quiz_results/QuizResultsChart";
import TeacherPortalConstructPerformanceChart from "../chart/construct_performance/ConstructPerformanceChart";
import TeacherPortalConstructActivityStats from "../chart/construct_performance/ConstructActivityStats";
import TeacherPortalLatestActivities from "../activities/LatestActivities";
import TeacherPortalStudentActivityWidget from "./StudentActivityWidget";

const TeacherPortalCourseDashboard = ({ activitiesWithUsageDataGroupedByType, quizesInformation, userEvents, loadMoreUserEvents, constructScores }) => {
    const increaseHeightOfQuizes = quizesInformation.length > 6;
    const [selectedConstruct, setSelectedConstruct] = React.useState(null);
    const cardClass = "min-w-0 rounded bg-background p-4 shadow-default";

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:gap-6">
            <section className="md:col-span-8">
                <div className={cardClass}>
                    <TeacherPortalStudentActivityWidget />
                </div>
            </section>
            <section className="md:col-span-4">
                <div className={cardClass}>
                    <h2 className="mb-4 text-xl font-semibold">Learning material usage</h2>

                </div>
            </section>
            <section className="md:col-span-12">
                <div className={cardClass}>
                    <TeacherPortalConstructPerformanceChart
                        constructScores={constructScores}
                        selectedConstructId={selectedConstruct?.constructid}
                        onSelectConstruct={(construct) =>
                            setSelectedConstruct(selectedConstruct?.constructid === construct.constructid ? null : construct)
                        }
                    />
                </div>
            </section>
            {selectedConstruct && (
                <section className="md:col-span-12">
                    <div className={cardClass}>
                        <h2 className="mb-4 text-xl font-semibold">
                            {"Learning activities: " + (selectedConstruct.construct_name || "Topic " + selectedConstruct.constructid)}
                        </h2>
                        <TeacherPortalConstructActivityStats construct={selectedConstruct} />
                    </div>
                </section>
            )}
            <section className="md:col-span-4">
                <div className={cardClass}>
                    <h2 className="mb-4 text-xl font-semibold">Learning material usage</h2>
                    <TeacherPortalLearningMaterialInteractionChart
                        activitiesWithUsageDataGroupedByType={activitiesWithUsageDataGroupedByType}
                        height={increaseHeightOfQuizes ? 900 : 400}
                    />
                </div>
            </section>
            <section className="md:col-span-4">
                <div className={cardClass}>
                    <h2 className="mb-4 text-xl font-semibold">Quiz results</h2>
                    <TeacherPortalQuizResultsChart
                        quizesInformation={quizesInformation}
                        minHeight={750}
                        maxHeight={increaseHeightOfQuizes ? 900 : 400}
                    />
                </div>
            </section>
            <section className="md:col-span-12">
                <div className={cardClass}>
                    <h2 className="mb-4 text-xl font-semibold">Latest Activities</h2>
                    <TeacherPortalLatestActivities userEvents={userEvents} loadMoreUserEvents={loadMoreUserEvents} />
                </div>
            </section>
        </div>
    );
};

export default TeacherPortalCourseDashboard;